export const multiCalendarPages = ["report","account-overview","optimizer/targeting"];